import {
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
  CONTACTS_INNER_ANALYTICS,
  CONTACT_ANALYTICS,
} from "constants/types";
import {
  getBouncedContactsListService,
  getContactDashboardService,
  getContentArticlesContactsService,
  getDeliveredContactsListService,
  getUnsubscribedContactsListService,
} from "modules/Services/AnalyticsService";
import store from "store";
import { setFirstTimeAllDataShown } from "../Dashboard/actions";

//Fetch delivered contacts for analytics
export const getDeliveredContactsList = (params: any = {}) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: CONTACT_ANALYTICS.DELIVERED_LOAD,
    });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  const firstTimeFilterShown = store.getState().analyticsDashboard.firstAllDataShown;

  getDeliveredContactsListService(params)
    .then((response) => {
      if (response.status === 200) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
        } else {
          store.dispatch({
            type: CONTACT_ANALYTICS.DELIVERED_SUCCESS,
            payload: {
              delivered: response.data.delivered,
              total_delivered: response.data.total_delivered,
              offset: params.offset,
            },
          });
          if (!firstTimeFilterShown) {
            setFirstTimeAllDataShown(true);
          }
        }
        if (response?.data?.total_delivered) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: { type: "contacts", total_delivered: response.data.total_delivered },
          });
        } else {
          const deliveredLength = store.getState().contactAnalytics?.delivered?.length;
          if (deliveredLength !== undefined && deliveredLength >= 0) {
            store.dispatch({
              type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
              payload: { type: "contacts", total_delivered: deliveredLength },
            });
          }
        }
        //! commenting this as it is being done down
        // store.dispatch({
        //   type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
        //   payload: { type: "contacts", total_delivered: response.data.total_delivered },
        // });
      } else {
        store.dispatch({
          type: CONTACT_ANALYTICS.DELIVERED_FAIL,
        });
      }
    })
    .catch((err) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: CONTACT_ANALYTICS.DELIVERED_FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
      console.log("Contacts Analytics Error: ", err);
    });
};

//Fetch bounced contacts for analytics
export const getBouncedContactsList = (params: any = {}) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: CONTACT_ANALYTICS.BOUNCED_LOAD,
    });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  getBouncedContactsListService(params)
    .then((response) => {
      if (response.status === 200) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
        } else {
          store.dispatch({
            type: CONTACT_ANALYTICS.BOUNCED_SUCCESS,
            payload: {
              bounced: response.data.bounced,
              total_bounced: response.data.total_bounced,
              offset: params.offset,
            },
          });
        }
        //! commenting this as it is being done down
        // store.dispatch({
        //   type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
        //   payload: { type: "contacts", total_bounced: response.data.total_bounced },
        // });
      } else {
        store.dispatch({
          type: CONTACT_ANALYTICS.BOUNCED_FAIL,
        });
      }
      if (response?.data?.total_bounced) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: { type: "contacts", total_bounced: response.data.total_bounced, offset: params.offset },
        });
      } else {
        const bouncedLength = store.getState().contactAnalytics?.bounced?.length;
        if (bouncedLength !== undefined && bouncedLength >= 0) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: { type: "contacts", total_bounced: bouncedLength },
          });
        }
      }
    })
    .catch((err) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: CONTACT_ANALYTICS.BOUNCED_FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
      console.log("Contacts Analytics Error: ", err);
    });
};

//Fetch unsubscribed contacts for analytics
export const getUnsubscribedContactsList = (params: any = {}) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: CONTACT_ANALYTICS.UNSUBSCRIBED_LOAD,
    });
  getUnsubscribedContactsListService(params)
    .then((response) => {
      if (response.status === 200) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
        } else {
          store.dispatch({
            type: CONTACT_ANALYTICS.UNSUBSCRIBED_SUCCESS,
            payload: {
              unsubscribed: response.data.unsubscribed,
              total_unsubscribed: response.data.total_unsubscribed,
              offset: params.offset,
            },
          });
        }
      } else {
        store.dispatch({
          type: CONTACT_ANALYTICS.UNSUBSCRIBED_FAIL,
        });
      }
      // store.dispatch({
      //   type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
      //   payload: { type: "contacts", total_unsubscribed: response.data.total_unsubscribed },
      // });
      if (response?.data?.total_unsubscribed) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: { type: "contacts", total_unsubscribed: response.data.total_bounced },
        });
      } else {
        const unsubscribedLength = store.getState().contactAnalytics?.unsubscribed?.length;
        if (unsubscribedLength !== undefined && unsubscribedLength >= 0) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: { type: "contacts", total_unsubscribed: unsubscribedLength },
          });
        }
      }
    })
    .catch((err) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: CONTACT_ANALYTICS.UNSUBSCRIBED_FAIL,
        });
      }
      console.log("Contacts Analytics Error: ", err);
    });
};

//Fetch content articles for contacts in analytics
export const getContentArticlesContacts = (params: any = {}) => {
  store.dispatch({
    type: CONTACTS_INNER_ANALYTICS.CONTENT_LOAD,
  });
  getContentArticlesContactsService(params)
    .then((response) => {
      if (response.status === 200) {
        store.dispatch({
          type: CONTACTS_INNER_ANALYTICS.CONTENT_SUCCESS,
          payload: { content: response.data.content_data },
        });
        store.dispatch({
          type: CONTACT_ANALYTICS.SELECTED_PERSON,
          payload: { selectedPerson: response.data.contact_details },
        });
      } else {
        store.dispatch({
          type: CONTACTS_INNER_ANALYTICS.CONTENT_FAIL,
        });
      }
    })
    .catch((err) => {
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.CONTENT_FAIL,
      });
      console.log("Contacts Analytics Error: ", err);
    });
};

//Fetch contacts dashboard for analytics
export const getContactDashboard = (params: any = {}, isCampaigns?: boolean) => {
  if (isCampaigns)
    store.dispatch({
      type: CONTACTS_INNER_ANALYTICS.CAMPAINGS_LOAD,
    });
  else
    store.dispatch({
      type: CONTACTS_INNER_ANALYTICS.DASHBOARD_LOAD,
    });
  getContactDashboardService(params)
    .then((response) => {
      if (response.status === 200) {
        store.dispatch({
          type: CONTACTS_INNER_ANALYTICS.DASHBOARD_SUCCESS,
          payload: { dashboard: response.data },
        });
        store.dispatch({
          type: CONTACT_ANALYTICS.SELECTED_PERSON,
          payload: { selectedPerson: response.data.contact_details },
        });
      } else {
        store.dispatch({
          type: CONTACTS_INNER_ANALYTICS.DASHBOARD_FAIL,
        });
      }
    })
    .catch((err) => {
      store.dispatch({
        type: CONTACTS_INNER_ANALYTICS.DASHBOARD_FAIL,
      });
      console.log("Contacts Analytics Error: ", err);
    });
};

export const resetFilterLabel = () => {
  store.dispatch({
    type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER,
    payload: "",
  });
};

export const setSearchContact = (text: string) => {
  store.dispatch({
    type: CONTACT_ANALYTICS.SET_SEARCH_TEST,
    payload: {
      search: text,
    },
  });
};

export const resetFilterbyContacts = () => {
  store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: "" });
};

export const resetAnalyticsContent = () => {
  store.dispatch({ type: CONTACTS_INNER_ANALYTICS.RESET_CONTACT_DETAILS });
  store.dispatch({
    type: CONTACT_ANALYTICS.SELECTED_PERSON_RESET,
  });
};
